<button
  class="stroked-button"
  (click)="onClick($event)"
  [disabled]="disabled"
  [attr.aria-disabled]="ariaDisabled || null"
  [ngClass]="ngClass"
  [type]="type"
  [attr.aria-label]="ariaLabel || null"
>
  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'left'"
    [icon]="[fontSet, fontIcon]"
    class="mr-2"
  >
  </fa-icon>

  <span class="whitespace-no-wrap translate-y">{{ text }}</span>

  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'right'"
    [icon]="[fontSet, fontIcon]"
    class="ml-2"
  >
  </fa-icon>
</button>
